import { useOrganization } from "../../App";
import { FeatureTemplatesList } from "../feature-templates/FeatureTemplatesList";
import { LoadingScreen } from "../ui/loading-spinner";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function FeatureTemplatesPage() {
  const { currentOrganization, isLoading } = useOrganization();
  const navigate = useNavigate();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  if (isLoading) {
    return <LoadingScreen text="Loading organization..." />;
  }

  if (!currentOrganization?.id) {
    return (
      <div className="flex flex-col items-center justify-center h-[50vh] space-y-4">
        <h3 className="text-lg font-medium">No Organization Selected</h3>
        <p className="text-muted-foreground">
          Please select an organization to view feature templates.
        </p>
      </div>
    );
  }

  // Handle create feature template
  const handleCreateFeatureTemplate = () => {
    setIsCreateDialogOpen(true);
  };
  
  // Define action buttons
  const actionButtons = [
    {
      label: "Create Template",
      onClick: handleCreateFeatureTemplate,
      icon: <Plus size={16} />,
      variant: "default" as const,
      className: "bg-primary hover:bg-primary/80 text-primary-foreground"
    }
  ];

  return (
    <DashboardLayout 
      activeItem="Feature Templates"
      title="Feature Templates"
      description="Create and manage feature templates for your application"
      actionButtons={actionButtons}
    >
      <FeatureTemplatesList 
        organizationId={currentOrganization.id}
        isCreateDialogOpen={isCreateDialogOpen}
        setIsCreateDialogOpen={setIsCreateDialogOpen}
      />
    </DashboardLayout>
  );
}